import type { EdgeAssignment, GrooveAssignment } from '../model/types';

/**
 * Block 14 «Раскрой» — мини-SVG кромок и пазов детали (общий модуль, refine #168-A).
 *
 * Вынесено verbatim из `PartsTab.tsx` (ячейки «Кромки»/«Пазы» таблицы деталей) для
 * переиспользования в печати (`CutPrintDetails`): цех видит схему кромок/пазов, а не
 * текст. Цвета — прототипные домен-иконки (`project.html`), НЕ из 5 locked-токенов
 * палитры (P-045 не нарушается). Read-only, без интерактива.
 */

const EMPTY_EDGES: EdgeAssignment = { top: '', bottom: '', left: '', right: '' };
const EMPTY_GROOVES: GrooveAssignment = { top: '', right: '', bottom: '', left: '' };

/** Mini-SVG кромок (вербатим project.html:233-237): rect + линии сторон.
    type1 — сплошная оранжевая, type2 — пунктирная коричневая. */
export function EdgeMiniSvg({ edges }: { edges?: EdgeAssignment }) {
  const e = edges ?? EMPTY_EDGES;
  const line = (side: keyof EdgeAssignment, x1: number, y1: number, x2: number, y2: number) => {
    const t = e[side];
    if (!t) return null;
    const solid = t === 'type1';
    return (
      <line
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke={solid ? '#ff9156' : '#7a6a5a'}
        strokeWidth="3"
        {...(solid ? {} : { strokeDasharray: '2,2' })}
      />
    );
  };
  return (
    <span className="cell-edge-icon">
      <svg viewBox="0 0 36 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="4" width="24" height="16" fill="white" stroke="#7a6a5a" strokeWidth="1" />
        {line('top', 6, 4, 30, 4)}
        {line('right', 30, 4, 30, 20)}
        {line('bottom', 6, 20, 30, 20)}
        {line('left', 6, 4, 6, 20)}
      </svg>
    </span>
  );
}

/** Цвет паза по типу (вербатим app.js:259 renderGrooveSvg colorOf). */
const GROOVE_COLOR: Record<string, string> = { v: '#ff9156', u: '#16A34A', l: '#D97706' };

/** Mini-SVG пазов (вербатим project.html renderGrooveSvg): rect + цветные линии
    сторон по типу паза (V=оранж / U=зелёный / L=янтарь). */
export function GrooveMiniSvg({ grooves }: { grooves?: GrooveAssignment }) {
  const g = grooves ?? EMPTY_GROOVES;
  const line = (side: keyof GrooveAssignment, x1: number, y1: number, x2: number, y2: number) => {
    const color = GROOVE_COLOR[g[side]];
    if (!color) return null;
    return <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="3" />;
  };
  return (
    <span className="cell-groove-icon">
      <svg viewBox="0 0 36 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="4" width="24" height="16" fill="white" stroke="#7a6a5a" strokeWidth="1" />
        {line('top', 6, 4, 30, 4)}
        {line('right', 30, 4, 30, 20)}
        {line('bottom', 6, 20, 30, 20)}
        {line('left', 6, 4, 6, 20)}
      </svg>
    </span>
  );
}
